import React, { useContext, useEffect } from "react";
import { flatten, unflatten } from "flat";
import {
	Formik,
	Form,
	Field,
	FieldArray,
	ErrorMessage,
	useFormikContext,
	setNestedObjectValues,
} from "formik";
import { Context } from "../inc/state";
import { Actions, Radio, FieldWrapper, AutoUpdateValues, YesNo, FundName } from "./fields";
import Accordion from "react-bootstrap/Accordion";

import errorMessages from "../inc/errorMessages";
import * as Yup from "yup";

import { PersonalFields, PersonalFieldsSchema } from "./PersonalFields";

export default () => {
	const [state, dispatch, setLoading] = useContext(Context);

	const handleSubmit = (values, { setSubmitting }) => {
		dispatch({ type: "ADD_DATA", payload: { values } });
		dispatch({ type: "STEP_FORWARD" });
	};

	const { fundOption } = state;

	// huwelijksgemeenschapVerbinden
	// onverdeeldheidVertegenwoordigen

	const validationSchema = Yup.object().shape({
		individuals: Yup.array().of(
			Yup.object()
				.concat(
					fundOption === 3 &&
						Yup.object().shape({
							huwelijksgemeenschapVerbinden: Yup.string().required(
								errorMessages.required
							),
						})
				)
				.concat(
					fundOption === 4 &&
						Yup.object().shape({
							onverdeeldheidVertegenwoordigen: Yup.string().required(
								errorMessages.required
							),
						})
				)
				.concat(PersonalFieldsSchema)
		),
	});

	const initialValues = state.values;

	const errorCount = (errors) => {
		let arr = [];

		if ("individuals" in errors) {
			const flat = Object.keys(flatten(errors.individuals));
			flat.forEach((element) => {
				const key = element.split(".");
				if (key.length > 1) {
					if (!arr[key[0]]) {
						arr[key[0]] = 0;
					}
					arr[key[0]]++;
				}
			});
		}

		return arr;
	};

	let heading = "Persoonlijke gegevens";
	switch (fundOption) {
		case 3:
			heading = "Aanspreking partner";
			break;
		case 4:
			heading = "Partner";
			break;
	}

	return (
		<Formik
			validationSchema={validationSchema}
			initialValues={initialValues}
			onSubmit={handleSubmit}
		>
			{({ values, errors, validateForm, setTouched, setFieldValue }) => {
				const { individuals } = values,
					errorCounts = errorCount(errors),
					isSingle = individuals.length < 2;

				return (
					<Form noValidate>
						<FundName title={state.fundTitle} subtitle={"Integra III Privak"} />

						<FieldArray name="individuals">
							<Accordion
								defaultActiveKey={[0]}
								flush
								className={isSingle ? "single" : ""}
							>
								{individuals.length > 0 &&
									individuals.map((individual, index) => {

										return (
											<Accordion.Item
												eventKey={index}
												key={`individuals.${index}`}
											>
												<Accordion.Header
													onClick={async () => {
														const e = await validateForm();
														setTouched(setNestedObjectValues(e, true));
													}}
												>
													{heading}
													{individuals.length > 1 && ` ${index + 1}`}
													{errorCounts && errorCounts[index] && (
														<div className="accordion-error">
															<span className="badge rounded-pill text-bg-light">
																{errorCounts[index]}
															</span>
														</div>
													)}
												</Accordion.Header>
												<Accordion.Body>
													<PersonalFields
														group={`individuals.${index}.`}
														isBelgium={individual.land==='België'}
													/>
													{fundOption === 3 && (
														<YesNo
															label="Zal deze partner ten aanzien van Integra worden aangeduid als exclusief houder van de stemrechten van de aandelen?"
															name={`individuals.${index}.huwelijksgemeenschapVerbinden`}
														/>
													)}
													{fundOption === 4 && (
														<YesNo
															label="Zal deze persoon ten aanzien van Integra worden aangeduid als exclusief houder van de stemrechten van de aandelen?"
															name={`individuals.${index}.onverdeeldheidVertegenwoordigen`}
														/>
													)}
												</Accordion.Body>
											</Accordion.Item>
										);
									})}
							</Accordion>
						</FieldArray>
						<AutoUpdateValues />
						<Actions />
					</Form>
				);
			}}
		</Formik>
	);
};
